import React, { useState } from "react";
import { FaIceCream, FaCookieBite, FaStore, FaUtensils } from "react-icons/fa";
import { Link, useNavigate } from "react-router-dom";

const models = [
  { name: "Scoop", category: "Display", image: "images/scoop.jpg", description: "A sleek and compact display unit for showcasing ice cream in a stylish, modern setting.", route: "/scoop" },
  { name: "Pura", category: "Display", image: "images/pura.jpg", description: "Minimalistic design offering a clean and neat presentation of ice cream products in an inviting manner.", route: "/pura" },
  
  { name: "Daisy", category: "Display", image: "images/daisyice.png", description: "Attractive ice cream presentation and easy service.", route: "/daisy-ice" },
  { name: "Kubo", category: "Display", image: "images/newkubo.jpg", description: "Contemporary design with a compact footprint, ideal for high-traffic ice cream parlors.", route: "/kubo" },
  { name: "E-Line", category: "Display", image: "images/neweline.jpg", description: "A modern, stylish display with a clean design, offering flexible usage for ice cream shops.", route: "/e-line" },
  { name: "Vista", category: "Display", image: "images/vista2.jpg", description: "Versatile and elegant display solution, perfect for showcasing ice cream in a premium setting.", route: "/vista" },
];



const icons = [
  { name: "Ice Cream", icon: <FaIceCream /> },
  { name: "Chocolate", icon: <FaCookieBite /> },
  { name: "Supermarket", icon: <FaStore /> },
  { name: "Restaurant", icon: <FaUtensils /> },
];

function Icecream() {
  const [currentPage, setCurrentPage] = useState(1);
  const modelsPerPage = 6;
  const navigate = useNavigate();

  // Get the current models for the current page
  const indexOfLastModel = currentPage * modelsPerPage;
  const indexOfFirstModel = indexOfLastModel - modelsPerPage;
  const currentModels = models.slice(indexOfFirstModel, indexOfLastModel);

  // Handle page change
  const handlePageChange = (pageNumber) => setCurrentPage(pageNumber);

  // Calculate total pages
  const totalPages = Math.ceil(models.length / modelsPerPage);

  return (
    <div className="w-full font-thin">
      {/* Hero Section */}
      <section
        className="relative text-center w-full h-[600px]"
        style={{
          backgroundImage: "url('images/iceland4.jpg')",
          backgroundSize: "cover",
          backgroundPosition: "center",
          backgroundRepeat: "no-repeat",
        }}
      >
       
      </section>

      {/* Models Display */}
      <section className="px-6 py-12 md:px-32">
        <section className="px-6 md:px-32">
        <div className="flex flex-col items-center justify-center text-black p-6">
          <h1 className="text-3xl mb-4 md:text-4xl text-center">Ice cream</h1>
          <p className="text-lg max-w-2xl text-center md:text-2xl text-gray-500">
          For the most refreshing Ice creams, Sorbets and Icebox cakes we created high performance display cases, which guarantee the most sophisticated flavours and perfect textures. Fancy a gelato?
          </p>
        </div>

        <div className="flex justify-center">
          <Link to="/" className="block py-1 pl-4 hover:underline mt-6">Home -</Link>
          <button className="block py-1 pl-4 hover:underline uppercase mt-6">Ice cream</button>
        </div>
      </section>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-10">
          {currentModels.map((model, index) => (
            <div key={index} onClick={() => navigate(model.route)} className="text-center cursor-pointer">
              <div
                className="relative w-full h-80 mb-4"
                style={{
                  backgroundImage: `url(${model.image})`,
                  backgroundSize: "contain", // Ensures no cuts, full image shown
                  backgroundPosition: "center",
                  backgroundRepeat: "no-repeat",
                  height: "300px",
                }}
              ></div>
              <h3 className="text-3xl uppercase font-thin mb-2">{model.name}</h3>
              {/* <p className="text-xl opacity-80 ">{model.category}</p> */}
              <p className="text-xl text-gray-500 max-w-sm opacity-80 mb-4 mx-auto">{model.description}</p>

              {/* Small icons under each model */}
              <div className="flex justify-center gap-4">
                {icons.map((icon, index) => (
                  <div key={index} className="text-2xl">
                    {icon.icon}
                  </div>
                ))}
              </div>
            </div>
          ))}
        </div>

        {/* Pagination */}
        <div className="flex justify-center mt-10">
          <button
            onClick={() => handlePageChange(currentPage - 1)}
            disabled={currentPage === 1}
            className="px-4 py-2 bg-gray-800 text-white rounded-l"
          >
            Previous
          </button>
          <span className="px-4 py-2">{`Page ${currentPage} of ${totalPages}`}</span>
          <button
            onClick={() => handlePageChange(currentPage + 1)}
            disabled={currentPage === totalPages}
            className="px-4 py-2 bg-gray-800 text-white rounded-r"
          >
            Next
          </button>
        </div>
      </section>
    </div>
  );
}

export default Icecream;

// import React, { useState } from "react";
// import { FaIceCream, FaCookieBite, FaStore, FaUtensils } from "react-icons/fa";

// const models = [
//   { name: "Scoop", category: "Display", image: "images/scoop.jpg", description: "A sleek and compact display unit for showcasing ice cream in a stylish, modern setting." },
//   { name: "Pura", category: "Display", image: "images/pura.jpg", description: "Minimalistic design offering a clean and neat presentation of ice cream products in an inviting manner." },
//   { name: "Daisy", category: "Display", image: "images/daisy.png", description: "Elegant and user-friendly display unit designed for a variety of ice cream types, perfect for any ice cream shop." },
//   { name: "Kubo", category: "Display", image: "images/kubo.jpg", description: "Contemporary design with a compact footprint, ideal for high-traffic ice cream parlors." },
//   { name: "E-Line", category: "Display", image: "images/eline.jpg", description: "A modern, stylish display with a clean design, offering flexible usage for ice cream shops." },
//   { name: "Vista", category: "Display", image: "images/vista.jpg", description: "Versatile and elegant display solution, perfect for showcasing ice cream in a premium setting." },
// ];

// const icons = [
//   { name: "Ice Cream", icon: <FaIceCream /> },
//   { name: "Chocolate", icon: <FaCookieBite /> },
//   { name: "Supermarket", icon: <FaStore /> },
//   { name: "Restaurant", icon: <FaUtensils /> },
// ];

// function Icecream() {
//   const [currentPage, setCurrentPage] = useState(1);
//   const modelsPerPage = 6;

//   // Get the current models for the current page
//   const indexOfLastModel = currentPage * modelsPerPage;
//   const indexOfFirstModel = indexOfLastModel - modelsPerPage;
//   const currentModels = models.slice(indexOfFirstModel, indexOfLastModel);

//   // Handle page change
//   const handlePageChange = (pageNumber) => setCurrentPage(pageNumber);

//   // Calculate total pages
//   const totalPages = Math.ceil(models.length / modelsPerPage);

//   return (
//     <div className="w-full">
//       {/* Hero Section */}
//       <section
//         className="relative text-center w-full h-screen"
//         style={{
//           backgroundImage: "url('images/iceland4.jpg')",
//           backgroundSize: "cover",
//           backgroundPosition: "contain",
//           backgroundRepeat: "no-repeat",
//         }}
//       >
//         <div className="absolute inset-0 flex flex-col items-center justify-center bg-black bg-opacity-50 text-white p-6">
//           <h1 className="text-4xl font-bold mb-4 md:text-8xl">Ice Cream</h1>
//           <p className="text-lg max-w-2xl md:text-3xl">
//             Discover the best models for displaying ice cream in your store, designed for style and functionality.
//           </p>
//         </div>
//       </section>

//       {/* Models Display */}
//       <section className="px-6 py-12 md:px-32">
//         <h2 className="text-4xl md:text-7xl font-bold text-center mb-10">Our Ice Cream Models</h2>

//         <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-10">
//           {currentModels.map((model, index) => (
//             <div key={index} className="text-center">
//               <div
//                 className="relative w-full h-80 mb-4"
//                 style={{
//                   backgroundImage: `url(${model.image})`,
//                   backgroundSize: "contain", // Ensures no cuts, full image shown
//                   backgroundPosition: "center",
//                   backgroundRepeat: "no-repeat",
//                   height: "300px",
//                 }}
//               ></div>
//               <h3 className="text-2xl font-semibold mb-2">{model.name}</h3>
//               <p className="text-sm opacity-80 ">{model.category}</p>
//               <p className="text-sm max-w-sm opacity-80 mb-4 mx-auto">{model.description}</p>

//               {/* Small icons under each model */}
//               <div className="flex justify-center gap-4">
//                 {icons.map((icon, index) => (
//                   <div key={index} className="text-2xl">
//                     {icon.icon}
//                   </div>
//                 ))}
//               </div>
//             </div>
//           ))}
//         </div>

//         {/* Pagination */}
//         <div className="flex justify-center mt-10">
//           <button
//             onClick={() => handlePageChange(currentPage - 1)}
//             disabled={currentPage === 1}
//             className="px-4 py-2 bg-gray-800 text-white rounded-l"
//           >
//             Previous
//           </button>
//           <span className="px-4 py-2">{`Page ${currentPage} of ${totalPages}`}</span>
//           <button
//             onClick={() => handlePageChange(currentPage + 1)}
//             disabled={currentPage === totalPages}
//             className="px-4 py-2 bg-gray-800 text-white rounded-r"
//           >
//             Next
//           </button>
//         </div>
//       </section>
//     </div>
//   );
// }

// export default Icecream;
